import React from 'react';
import './App.scss';
import Navigation from './components/global/Navigation';

function App() {
  return (
     <Navigation/>
  );
}

export default App;
